import { Component, OnInit } from '@angular/core';

import { LanguageService } from './../rest/api/language.service';
import * as _ from 'lodash';
import { PageService } from '../rest/api/page.service';
import {TranslateService} from '@ngx-translate/core';
import { SettingService } from '../rest/api/setting.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  fooMenu: any;
  lang: any;
  constructor(
    public languageService: LanguageService,
    public pageService: PageService,
    public settingService: SettingService,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
    this.getFooterMenu();
  }

  getFooterMenu() {
    this.pageService.getMenuList(this.lang).subscribe((response: any) => {
    let fooMenu = response.data;
    fooMenu = _.filter(fooMenu, {show_in_footer: 1});
    this.fooMenu = _.orderBy(fooMenu,  ['position'], ['asc']);
   }, err => {
    this.fooMenu = [];
   });
  }

}
